import React from 'react';
import Table from '../../../../components/tables/Table';

const COLUMNS = [
  {
    label: 'Status',
    field: 'unitStatus',
    type: 'string',
    sortable: true,
    render: (_row, v) => v ?? '—',
  },
  {
    label: 'Operator',
    field: 'Description',
    type: 'string',
    sortable: true,
    render: (_row, v) => (typeof v === 'string' ? v.trim() : v) || '—',
  },
  {
    label: 'From',
    field: 'EFDT',
    type: 'date',
    sortable: true,
  },
  {
    label: 'To',
    field: 'ETDT',
    type: 'date',
    sortable: true,
  },
  {
    label: 'Stood Down',
    field: 'StoodDown',
    type: 'boolean',
    sortable: true,
    accessor: (row) =>
      row?.StoodDown === true || row?.StoodDown === 1 || row?.StoodDown === '1',
  },
];

export default function UnitVersionTable({ rows = [] }) {
  return (
    <Table
      rows={rows}
      columns={COLUMNS}
      stickyHeader
      zebra
      hover
      bordered

    />
  );
}
